<script>
import ListingModel from "@/views/WorkerBalance/Components/ListingModel.vue";

export default {
    components: {ListingModel}

};
</script>

<template>
    <listing-model
        :vacation="false"
        root-path="absence_requests_balance"
    />
</template>
